export const icons = [];
icons["RED_FACE"] =  "EmojiDisappointed";
icons["YELLOW_FACE"] =  "EmojiDisappointed";
icons["GREEN_FACE"] =  "EmojiDisappointed";